import { useNavigate } from '@fukuri-admins/hooks/common';
import { useAlertDialog } from '@fukuri-admins/ui/common/AlertDialog';
import { setStressAssessmentRole } from '@fukuri-admins/utils/common/cookies';
import { useState } from 'react';
import { StressAssessmentRole } from '~/types/model/stressAssessment';
import { ROUTES } from '~/utils/routes';

type IUseStressAssessmentRoleSelect = () => {
  state: {
    selectedRole: StressAssessmentRole;
  };
  actions: {
    handleRoleChange: (role: StressAssessmentRole) => void;
    handleSubmit: () => void;
  };
};

const ALERT_TITLE = '実施者権限での利用をはじめますか？';
const ALERT_MESSAGE =
  '本権限は、産業医・保健師専用です。プライバシー保護と法令遵守のため、企業担当者の方は利用できません。選択された権限でよろしいですか。';

export const useStressAssessmentRoleSelect: IUseStressAssessmentRoleSelect = () => {
  const [selectedRole, setSelectedRole] = useState<StressAssessmentRole>('practitioner');
  const navigate = useNavigate();
  const { showAlertDialog } = useAlertDialog();

  const handleRoleChange = (role: StressAssessmentRole) => {
    setSelectedRole(role);
  };

  const handleOnConfirm = async () => {
    /** cookieにselectedRoleを保存 */
    setStressAssessmentRole(selectedRole);

    await navigate(ROUTES.STRESS_ASSESSMENTS.INDEX);
  };

  const handleSubmit = async () => {
    if (selectedRole === 'implementer') {
      showAlertDialog({
        title: ALERT_TITLE,
        message: ALERT_MESSAGE,
        confirmText: '利用を始める',
        cancelText: '選択し直す',
        onConfirm: handleOnConfirm,
      });
    } else {
      await handleOnConfirm();
    }
  };

  return {
    state: { selectedRole },
    actions: { handleRoleChange, handleSubmit },
  };
};
